import { MEMBERSHIP_1YEAR_SKU } from '@/app/[locale]/store/_consts';
import MembershipSelectionEnum from '@/app/enums/MembershipSelectionEnum';

const getMembershipSku = (
  selection: MembershipSelectionEnum | undefined,
): string => {
  switch (selection) {
    case MembershipSelectionEnum.OneYear:
      return MEMBERSHIP_1YEAR_SKU;
    case MembershipSelectionEnum.OneMonth:
      return '';
    default:
      return '';
  }
};
export default getMembershipSku;
